import React from 'react';
import { Step } from './Step';
import bookIcon from './assets/book.svg';
import earnIcon from './assets/earn.svg';
import redeemIcon from './assets/redeem.svg';
import styles from './InstructionSteps.module.css';

export type InstructionStepsProps = {
  book: { label: string; description: string };
  earn: { label: string; description: string };
  redeem: { label: string; description: string };
};

export const InstructionSteps = ({
  book,
  earn,
  redeem,
}: InstructionStepsProps) => {
  return (
    <ol className={styles.grid}>
      <li>
        <Step
          icon={bookIcon}
          label={book.label}
          description={book.description}
        />
      </li>
      <li>
        <Step
          icon={earnIcon}
          label={earn.label}
          description={earn.description}
        />
      </li>
      <li>
        <Step
          icon={redeemIcon}
          label={redeem.label}
          description={redeem.description}
        />
      </li>
    </ol>
  );
};
